// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TPublicOfferCheckBusinessEntityModel,
  IMappers,
  TPublicOfferCheckBusinessEntityResponse,
  IPublicOfferCheckBusinessEntityResponse,
  IPublicOfferCheckBusinessEntityResponseError,
} from './types';

export const defaultConfig: TPublicOfferCheckBusinessEntityModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'dailyrent',
  pathApi: '/v1/public-offer/check-business-entity/',
} as TPublicOfferCheckBusinessEntityModel;

export function createPublicOfferCheckBusinessEntityModel(): TPublicOfferCheckBusinessEntityModel {
  return {
    ...defaultConfig,
  };
}

export interface IPublicOfferCheckBusinessEntityOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchPublicOfferCheckBusinessEntity<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IPublicOfferCheckBusinessEntityOptions<TResponse200, TResponse400>): Promise<
  TPublicOfferCheckBusinessEntityResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createPublicOfferCheckBusinessEntityModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicOfferCheckBusinessEntityResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicOfferCheckBusinessEntityResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicOfferCheckBusinessEntityResponse;
}
